import { useState, useEffect } from 'react';
import api from '../../servicios/api';
import { obtenerTodasConfiguraciones, guardarConfiguracion, probarTodasLasNotificaciones } from '../../servicios/notificacionesService';

const CARGO_COLORS = {
  'Administrador': '#111827',
  'Supervisor':    '#374151',
  'Inspector':     '#4b5563',
  'Bodeguero':     '#6b7280',
  'Operador':      '#9ca3af',
};
const cargoColor = (cargo) => CARGO_COLORS[cargo] || '#6b7280';

function ConfiguracionNotificaciones({ usuarioActual }) {
  const [abierto, setAbierto] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [proyectos, setProyectos] = useState([]);
  const [configsNotif, setConfigsNotif] = useState([]);
  const [proyectoExpandido, setProyectoExpandido] = useState(null);
  const [guardandoNotif, setGuardandoNotif] = useState(null);
  const [probando, setProbando] = useState(false);
  const [resultadoPrueba, setResultadoPrueba] = useState(null);
  const [destEditados, setDestEditados] = useState({});

  const esPropietario = usuarioActual?.tipoUsuario === 'propietario';
  const esGerente = usuarioActual?.tipoUsuario === 'gerente';
  const tieneAcceso = esPropietario || esGerente;

  useEffect(() => {
    if (!tieneAcceso) { setCargando(false); return; }
    Promise.all([
      api.get('/dashboard/global'),
      obtenerTodasConfiguraciones()
    ])
      .then(([res, configs]) => {
        setProyectos(res.data?.proyectos || []);
        setConfigsNotif(configs || []);
        const initDest = {};
        (configs || []).forEach(c => { initDest[c.proyectoId] = c.destinatarios || []; });
        setDestEditados(initDest);
      })
      .catch(() => {})
      .finally(() => setCargando(false));
  }, [tieneAcceso]);

  const handleToggleNotif = async (proyectoId, habilitadaActual) => {
    const config = configsNotif.find(c => String(c.proyectoId) === String(proyectoId));
    const nuevaHabilitada = !habilitadaActual;
    setConfigsNotif(prev => prev.map(c => String(c.proyectoId) === String(proyectoId) ? { ...c, habilitada: nuevaHabilitada } : c));
    try {
      await guardarConfiguracion({
        proyectoId,
        usuarioEmail: usuarioActual?.email || '',
        habilitada: nuevaHabilitada,
        diaSemana: 1, hora: 8, minuto: 30,
        destinatarios: config?.destinatarios || []
      });
    } catch {
      setConfigsNotif(prev => prev.map(c => String(c.proyectoId) === String(proyectoId) ? { ...c, habilitada: habilitadaActual } : c));
    }
  };

  const handleGuardarDestinatarios = async (proyectoId) => {
    const config = configsNotif.find(c => String(c.proyectoId) === String(proyectoId));
    setGuardandoNotif(proyectoId);
    try {
      await guardarConfiguracion({
        proyectoId,
        usuarioEmail: usuarioActual?.email || '',
        habilitada: config?.habilitada ?? false,
        diaSemana: 1, hora: 8, minuto: 30,
        destinatarios: destEditados[proyectoId] || []
      });
      setConfigsNotif(prev => prev.map(c =>
        String(c.proyectoId) === String(proyectoId)
          ? { ...c, destinatarios: destEditados[proyectoId] || [] }
          : c
      ));
      setProyectoExpandido(null);
    } catch {
      alert('Error al guardar configuración');
    } finally {
      setGuardandoNotif(null);
    }
  };

  const toggleDestinatario = (proyectoId, miembro) => {
    setDestEditados(prev => {
      const actual = prev[proyectoId] || [];
      const existe = actual.some(d => d.email === miembro.email);
      return {
        ...prev,
        [proyectoId]: existe
          ? actual.filter(d => d.email !== miembro.email)
          : [...actual, { nombre: miembro.nombre, email: miembro.email, tiposNotificacion: { gestracoo: true, recepcion: true } }]
      };
    });
  };

  const toggleTipoMiembro = (proyectoId, email, tipo) => {
    setDestEditados(prev => {
      const actual = prev[proyectoId] || [];
      return {
        ...prev,
        [proyectoId]: actual.map(d =>
          d.email === email
            ? { ...d, tiposNotificacion: { ...(d.tiposNotificacion || { gestracoo: true, recepcion: true }), [tipo]: !(d.tiposNotificacion?.[tipo] ?? true) } }
            : d
        )
      };
    });
  };

  const handleProbarTodo = async () => {
    setProbando(true);
    setResultadoPrueba(null);
    try {
      const respuesta = await probarTodasLasNotificaciones();
      setResultadoPrueba({ ok: true, mensaje: respuesta.mensaje || 'Notificaciones de prueba enviadas.' });
    } catch (err) {
      setResultadoPrueba({ ok: false, mensaje: err.mensaje || err.error || 'Error al enviar la prueba.' });
    } finally {
      setProbando(false);
      setTimeout(() => setResultadoPrueba(null), 6000);
    }
  };

  if (!tieneAcceso || cargando || configsNotif.length === 0) return null;

  return (
    <div className="config-card">
      <h3
        className={`config-card-title config-card-title-toggle ${abierto ? 'open' : ''}`}
        onClick={() => setAbierto(o => !o)}
      >
        Notificaciones Automáticas
        <span className="config-card-chevron">▸</span>
      </h3>
      {abierto && (
        <div>
          <div style={{ background: '#fafafa', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '14px 16px', marginBottom: '18px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
              <button
                type="button"
                onClick={handleProbarTodo}
                disabled={probando}
                className="config-submit-btn"
                style={{ padding: '8px 18px', fontSize: '13px', opacity: probando ? 0.7 : 1, cursor: probando ? 'not-allowed' : 'pointer' }}
              >
                {probando ? 'Enviando...' : 'Enviar notificación de prueba a todos'}
              </button>
              {resultadoPrueba && (
                <span style={{ fontSize: '12px', fontWeight: '600', color: resultadoPrueba.ok ? '#16a34a' : '#dc2626' }}>
                  {resultadoPrueba.ok ? '✓' : '✕'} {resultadoPrueba.mensaje}
                </span>
              )}
            </div>
            <p style={{ margin: '8px 0 0', fontSize: '11px', color: '#9ca3af' }}>
              Envía Ruta Crítica y Resumen Gerencial a todos los destinatarios y gerentes habilitados, marcados como [PRUEBA] en el asunto.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {configsNotif.map(config => {
              const pid = String(config.proyectoId);
              const proyData = proyectos.find(i => String(i.proyecto?.id || i.proyecto?._id) === pid);
              const miembrosProyecto = proyData?.miembros || [];
              const expandido = proyectoExpandido === pid;
              const destActuales = destEditados[pid] || [];
              const ninguno = destActuales.length === 0;

              return (
                <div key={pid} style={{ background: '#fff', border: '1px solid #e5e7eb', borderLeft: `4px solid ${config.habilitada ? '#111827' : '#d1d5db'}`, borderRadius: '10px', overflow: 'hidden' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px' }}>
                    <button
                      type="button"
                      onClick={() => handleToggleNotif(pid, config.habilitada)}
                      title={config.habilitada ? 'Desactivar' : 'Activar'}
                      style={{
                        width: '40px', height: '22px', borderRadius: '11px', border: 'none', cursor: 'pointer', flexShrink: 0,
                        background: config.habilitada ? '#111827' : '#d1d5db', position: 'relative', transition: 'background 0.2s'
                      }}
                    >
                      <span style={{
                        position: 'absolute', top: '3px', left: config.habilitada ? '21px' : '3px',
                        width: '16px', height: '16px', borderRadius: '50%', background: '#fff', transition: 'left 0.2s', display: 'block'
                      }} />
                    </button>

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <p style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {config.proyectoNombre}
                      </p>
                      <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#6b7280' }}>
                        {config.habilitada ? '● Activa' : '○ Inactiva'}
                        {config.ultimoEnvio && <span style={{ marginLeft: '8px' }}>· Último envío: {new Date(config.ultimoEnvio).toLocaleDateString('es-CL')}</span>}
                      </p>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '3px', flexShrink: 0 }}>
                      <span style={{ fontSize: '11px', color: '#6b7280', background: '#f3f4f6', padding: '3px 8px', borderRadius: '10px' }}>
                        {ninguno ? `Todos (${miembrosProyecto.length})` : `${destActuales.length} de ${miembrosProyecto.length}`}
                      </span>
                      {!ninguno && destActuales.length > 0 && (
                        <div style={{ display: 'flex', gap: '3px' }}>
                          {destActuales.some(d => (d.tiposNotificacion?.gestracoo ?? true) !== false) && (
                            <span style={{ fontSize: '10px', fontWeight: '600', background: '#f3f4f6', color: '#111827', border: '1px solid #d1d5db', padding: '1px 6px', borderRadius: '8px' }}>SC/Mat</span>
                          )}
                          {destActuales.some(d => (d.tiposNotificacion?.recepcion ?? true) !== false) && (
                            <span style={{ fontSize: '10px', fontWeight: '600', background: '#e5e7eb', color: '#374151', border: '1px solid #9ca3af', padding: '1px 6px', borderRadius: '8px' }}>Recep</span>
                          )}
                        </div>
                      )}
                    </div>

                    {miembrosProyecto.length > 0 && (
                      <button
                        type="button"
                        onClick={() => setProyectoExpandido(expandido ? null : pid)}
                        style={{ padding: '5px 12px', fontSize: '12px', fontWeight: '600', border: '1px solid #d1d5db', borderRadius: '6px', background: expandido ? '#111827' : '#fff', color: expandido ? '#fff' : '#374151', cursor: 'pointer', flexShrink: 0 }}
                      >
                        Destinatarios {expandido ? '▲' : '▼'}
                      </button>
                    )}
                  </div>

                  {expandido && (
                    <div style={{ borderTop: '1px solid #f3f4f6', padding: '14px 16px', background: '#fafafa' }}>
                      <p style={{ fontSize: '12px', color: '#6b7280', margin: '0 0 10px' }}>
                        Selecciona quiénes reciben notificaciones y qué tipo le llega a cada uno. Sin selección = todos reciben todo.
                      </p>

                      <div style={{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
                        <span style={{ fontSize: '11px', fontWeight: '600', background: '#f3f4f6', color: '#111827', border: '1px solid #d1d5db', padding: '3px 8px', borderRadius: '8px' }}>SC/Mat = Subcontratos y Materiales</span>
                        <span style={{ fontSize: '11px', fontWeight: '600', background: '#e5e7eb', color: '#374151', border: '1px solid #9ca3af', padding: '3px 8px', borderRadius: '8px' }}>Recep = Recepción</span>
                      </div>

                      <div
                        onClick={() => setDestEditados(prev => ({ ...prev, [pid]: [] }))}
                        style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '8px 10px', borderRadius: '8px', background: ninguno ? '#f3f4f6' : '#fff', border: `1px solid ${ninguno ? '#111827' : '#e5e7eb'}`, marginBottom: '6px' }}
                      >
                        <input type="checkbox" readOnly checked={ninguno} style={{ accentColor: '#111827', width: '15px', height: '15px', cursor: 'pointer' }} />
                        <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827', flex: 1 }}>Todos los miembros</span>
                        <span style={{ fontSize: '11px', color: '#6b7280' }}>SC/Mat + Cert · {miembrosProyecto.length} personas</span>
                      </div>

                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '8px 0' }}>
                        <div style={{ flex: 1, height: '1px', background: '#e5e7eb' }} />
                        <span style={{ fontSize: '11px', color: '#9ca3af' }}>o configura individualmente</span>
                        <div style={{ flex: 1, height: '1px', background: '#e5e7eb' }} />
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                        {miembrosProyecto.map((m, idx) => {
                          const seleccionado = destActuales.some(d => d.email === m.email);
                          const confDest = destActuales.find(d => d.email === m.email);
                          const tiposMiembro = confDest?.tiposNotificacion || { gestracoo: true, recepcion: true };

                          return (
                            <div key={`${m._id || m.email}-${idx}`} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', borderRadius: '8px', background: seleccionado ? '#f3f4f6' : '#fff', border: `1px solid ${seleccionado ? '#9ca3af' : '#e5e7eb'}` }}>
                              <input
                                type="checkbox"
                                checked={seleccionado}
                                onChange={() => toggleDestinatario(pid, m)}
                                style={{ accentColor: '#111827', width: '15px', height: '15px', cursor: 'pointer', flexShrink: 0 }}
                              />

                              <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: cargoColor(m.cargo), color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '700', flexShrink: 0 }}>
                                {(m.nombre || '?').charAt(0).toUpperCase()}
                              </div>

                              <div style={{ flex: 1, minWidth: 0 }}>
                                <p style={{ margin: 0, fontSize: '13px', fontWeight: '600', color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.nombre}</p>
                                <p style={{ margin: 0, fontSize: '11px', color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.email}</p>
                              </div>

                              {seleccionado ? (
                                <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                                  {[
                                    { key: 'gestracoo', label: 'SC/Mat', color: '#111827', bg: '#f3f4f6', border: '#d1d5db' },
                                    { key: 'recepcion',     label: 'Recep',  color: '#374151', bg: '#e5e7eb', border: '#9ca3af' }
                                  ].map(({ key, label, color, bg, border }) => {
                                    const activo = tiposMiembro[key] !== false;
                                    return (
                                      <button
                                        key={key}
                                        type="button"
                                        onClick={e => { e.stopPropagation(); toggleTipoMiembro(pid, m.email, key); }}
                                        title={activo ? `Desactivar ${label}` : `Activar ${label}`}
                                        style={{
                                          padding: '3px 8px', fontSize: '11px', fontWeight: '700', borderRadius: '8px', cursor: 'pointer', border: `1px solid ${activo ? border : '#e5e7eb'}`,
                                          background: activo ? bg : '#f9fafb', color: activo ? color : '#d1d5db', transition: 'all 0.15s'
                                        }}
                                      >
                                        {label}
                                      </button>
                                    );
                                  })}
                                </div>
                              ) : (
                                <span style={{ fontSize: '11px', color: '#d1d5db', flexShrink: 0 }}>sin notif.</span>
                              )}
                            </div>
                          );
                        })}
                      </div>

                      <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
                        <button
                          type="button"
                          onClick={() => handleGuardarDestinatarios(pid)}
                          disabled={guardandoNotif === pid}
                          className="config-submit-btn"
                          style={{ padding: '8px 20px', fontSize: '13px' }}
                        >
                          {guardandoNotif === pid ? 'Guardando...' : 'Guardar'}
                        </button>
                        <button
                          type="button"
                          onClick={() => setProyectoExpandido(null)}
                          style={{ padding: '8px 16px', background: 'transparent', color: '#6b7280', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default ConfiguracionNotificaciones;
